/*
 * @Description:
 * @Date: 2021-06-17 15:05:33
 */

import { setCacheForInput } from '../service.js';

import { moneyFixed } from '@/tools/money';

/**
 * @description: 根据选中集合遍历当前数据是否已选中
 * @param {array} selection 选中集合
 * @param {object} row 当前数据
 * @return {boolean} true当前存在选中集合中，false不再其中
 */
const getStateByCurrentRowSelecte = (selection, row) => {
  return selection.some(item => item.id === row.id);
};

export default {
  initFinishSum: {
    label: '预计可结算任务量',
    prop: 'initFinishSum',
    width: '140px'
  },
  serviceRate: {
    label: '服务费率',
    prop: 'serviceScale',
    formatter(r, c, v) {
      return v || '-';
    }
  },
  totalPrice: {
    label: '结算总价',
    prop: 'totalPrice',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  taskNumHandler: {
    label: '结算任务量',
    width: '150px',
    render(h, ctx, row) {
      const parent = ctx.parent;
      const selection = parent.$refs.table.selection || [];
      const stateByCurrentRowSelecte = getStateByCurrentRowSelecte(
        selection,
        row
      );
      // 改变后会重载table下统计数据
      const setTaskNum = async e => {
        const value = +e;
        if (isNaN(value) || value < 0 || /\./.test(value)) {
          parent.$message('请输入正确任务量');
          return;
        }
        if (value > row.initFinishSum) {
          parent.$message(`该条中【结算任务量】最多为${row.initFinishSum}`);
          return;
        }

        row._customizeNum = value;
        // 方便用户删除数值后重新输入内容
        if (value <= 0) {
          parent.$message(
            '【结算任务量】需大于0，为0则按当前默认可结算任务量计算'
          );
        }
        if (value > 0) {
          const data = await setCacheForInput(row);
          row.totalPrice = data.dynamicPrice;
        }
      };
      return (
        <el-input
          style="width:100px;padding:5px;border-radius:5px"
          type="number"
          placeholder="请输入内容"
          disabled={!stateByCurrentRowSelecte}
          value={row._customizeNum}
          onInput={setTaskNum}
        />
      );
    }
  }
};
